const moduleNameKey = "machineGroupsListAdminPanel";

export const machineGroupsListAdminPanelEn = {
  [moduleNameKey]: {
    noMachineGroups: "No Machine Groups found",
    failedToFetchMachineGroups: "Failed to fetch machine groups",
    expandGroup: "Expand",
    collapseGroup: "Collapse",
    editGroup: "Edit",
    sources: "sources",
  },
};

export const machineGroupsListAdminPanelPtBr = {
  [moduleNameKey]: {
    noMachineGroups: "Nenhum grupo de máquinas encontrado",
    failedToFetchMachineGroups: "Falha ao buscar grupos de máquinas",
    expandGroup: "Expandir",
    collapseGroup: "Recolher",
    editGroup: "Editar",
    sources: "fontes",
  },
};

export const machineGroupsListAdminPanelDe = {
  [moduleNameKey]: {
    noMachineGroups: "Keine Maschinengruppen gefunden",
    failedToFetchMachineGroups:
      "Maschinengruppen konnten nicht abgerufen werden",
    expandGroup: "Erweitern",
    collapseGroup: "Einklappen",
    editGroup: "Bearbeiten",
    sources: "Quellen",
  },
};

export const machineGroupsListAdminPanelZhHans = {
  [moduleNameKey]: {
    noMachineGroups: "未找到机器组",
    failedToFetchMachineGroups: "获取机器组失败",
    expandGroup: "展开",
    collapseGroup: "收起",
    editGroup: "编辑",
    sources: "个来源",
  },
};

export const machineGroupsListAdminPanelIt = {
  [moduleNameKey]: {
    noMachineGroups: "Nessun gruppo di macchine trovato",
    failedToFetchMachineGroups: "Impossibile recuperare i gruppi di macchine",
    expandGroup: "Espandi",
    collapseGroup: "Comprimi",
    editGroup: "Modifica",
    sources: "fonti",
  },
};

export const machineGroupsListAdminPanelEs = {
  [moduleNameKey]: {
    noMachineGroups: "No se encontraron grupos de máquinas",
    failedToFetchMachineGroups: "No se pudieron obtener los grupos de máquinas",
    expandGroup: "Expandir",
    collapseGroup: "Contraer",
    editGroup: "Editar",
    sources: "fuentes",
  },
};

export const machineGroupsListAdminPanelNl = {
  [moduleNameKey]: {
    noMachineGroups: "Geen machinegroepen gevonden",
    failedToFetchMachineGroups: "Machinegroepen ophalen is mislukt",
    expandGroup: "Uitklappen",
    collapseGroup: "Inklappen",
    editGroup: "Bewerken",
    sources: "bronnen",
  },
};

export const machineGroupsListAdminPanelTr = {
  [moduleNameKey]: {
    noMachineGroups: "Makine grubu bulunamadı",
    failedToFetchMachineGroups: "Makine grupları alınamadı",
    expandGroup: "Genişlet",
    collapseGroup: "Daralt",
    editGroup: "Düzenle",
    sources: "kaynak",
  },
};
